import { Col, Form } from "react-bootstrap";

export default function MinMaxYearPicker({ filterData, setFilterData, name, inputOnly = false }) {
    const input = (
        <Col className=" d-flex align-items-center column-gap-2">
            <span>MIN</span>
            {renderInputField("minYear")}
            <span>MAX</span>
            {renderInputField("maxYear")}
        </Col>
    );

    if (inputOnly) return input;

    function renderInputField(field) {
        return (
            <Form.Control
                type="number"
                className=" d-inline-block year-input"
                value={filterData[field].toString()}
                onChange={e =>
                    setFilterData({
                        ...filterData,
                        [field]: Number(e.target.value),
                    })
                }
                min={0}
            />
        );
    }

    return (
        <Form.Group as={Col} className="col-12 col-xl-2 me-3">
            <Form.Label className="d-flex column-gap-1">Release Year</Form.Label>
            {input}
        </Form.Group>
    );
}
